export const FANDOM_CONSENT_UPDATE = "fandomConsentUpdate";
export const FANDOM_CONTEXT_UPDATE = "fandomContextUpdate";
